import * as React from 'react'
import axios from 'axios'
import './FloatCoupon.css'
import CountDownSpecial from './CountDownSpecial/CountDownSpecial'
import {isProduction} from "../../../core/env";
import { prodConfig } from '../../../config'

class FloatCoupon extends React.Component {
    constructor() {
        super()
        this.state = {
            useStatus: 0,
            deadline: 0,
            price: 0,
            inviter_id: 0,
            init: false,
            isLessThanSetTime: false
        }
    }
    // 红包返回状态说明
    // code 为 3，就是用完了
    // code 为 2，是已经过期
    // code 为 1，是未领取
    // code 为 0  领取了还没用

    componentDidMount() {
        const params = {
            bag_id: 42,
            need_ab: true
        }
        axios.get('/operating/api/bag/display', {params}).then((res) => {
            if (res.status === 200) {
                this.setState({
                    useStatus: res.data.code,
                    deadline: res.data.data.deadline ? res.data.data.deadline : 0,
                    inviter_id: res.data.data.inviter_id,
                    price: res.data.data.price,
                    init: true
                }, () => {
                    const timeRemaining = parseFloat((Number(this.state.deadline) * 1000 - new Date().getTime()).toString())
                    if (Math.floor(timeRemaining / (3600 * 1000)) < 48) {
                        this.setState({
                            isLessThanSetTime: true
                        })
                    }
                })
            }
        })
    }

    getLink() {
        const {inviter_id} = this.state
        let prefix = ''
        if (isProduction()) {
            prefix = prodConfig.MAIN_URL
        } else {
            prefix = 'http://dbg.weike.fm'
        }
        if (inviter_id === 44006949) {
            return window.location.href = `${prefix}/coupons-bag/coupon?bagid=42&inviter_id=${inviter_id}`
        } else {
            return window.location.href = `${prefix}/coupons-bag/coupon?bagid=42b&inviter_id=${inviter_id}`
        }
    }

    gotoNewYearActivity() {
        if (window.location.pathname.indexOf('/specials/mywk') > -1) {
            window.location.assign('https://wk-activity.tryweike.cn/newyears/redpacket?entries=mywk')
        } else {
            window.location.assign('https://wk-activity.tryweike.cn/newyears/redpacket?entries=account')
        }
    }

    render() {
        if (!this.state.init) {
            return null
        }

        if (this.state.init && (this.state.useStatus === 3 || this.state.useStatus === 2)) {
            return (
                <div className="FloatCouponSpecial">
                <a className="FloatCouponWrap" onClick={() => this.gotoNewYearActivity()}>
                    <div className="newYearIcon">
                        <img src="https://static-1253442168.image.myqcloud.com/picture/10490565_54e1e3dd01227bd313e77c05dd7af450.jpg" alt=""/>
                    </div>
                 </a>
               </div>
            )
        }
        return (
            <div className="FloatCouponSpecial">
                <a className="FloatCouponWrap" onClick={() => this.getLink()}>
                    {this.state.useStatus === 0 && this.state.isLessThanSetTime &&
                    <div className="FloatCouponArea">
                        <img src={require('./images/H5syfc.png')} alt=""/>
                        <CountDownSpecial endTime={this.state.deadline.toString()}/>
                    </div>}

                    {this.state.useStatus === 1 &&
                    <div className="FloatCouponArea">
                        <img src={require('./images/H5ljlq.gif')} alt=""/>
                    </div>}

                    {this.state.useStatus === 0 && !this.state.isLessThanSetTime &&
                    <div className="FloatCouponArea">
                        <img src={require('./images/H5jjgq.gif')} alt=""/>
                    </div>}
                </a>
            </div>
        )
    }

}

export default FloatCoupon



// WEBPACK FOOTER //
// ./src/components/activity/FloatCouponSpecial/FloatCoupon.js